import { DataAddType } from '../../common/enumerations/data-add-type';
import { DataUndefined } from '../../common/helpers/error-code';
import { IDataInformation } from '../../common/interfaces/dtos/IDataInformation';
import { IItemInputData } from '../../common/interfaces/IItemInputData';
import { store } from '../../common/redux/configure-store';
import { dataAdd } from './service/data-add';

export const getDataInformation = async (inputData: IItemInputData): Promise<IDataInformation> => {
  const transactionId = store.getState().transaction.transactionId;
  return dataAdd(transactionId, inputData).catch(
    (err): IDataInformation => {
      if (err.code === DataUndefined) {
        return {
          id: inputData.itemId,
          type: DataAddType.Item,
        };
      } else {
        throw err;
      }
    },
  );
};
